import { Component, inject, Inject, Input, Optional } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MaterialModule } from '../../material/material.module';

@Component({
  selector: 'candidate-analysis',
  imports: [MaterialModule],
  templateUrl: './candidate-analysis.component.html',
  styleUrl: './candidate-analysis.component.scss',
})
export class CandidateAnalysisComponent {
  @Input() candidate: any;
  private _bottomSheetRef: any;
  @Input() showCloseButton = true;

  constructor(@Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data?: any) {
    this.candidate = data;
    if (this.candidate?.resume_analysis?.candidate_id) {
      this._bottomSheetRef =
        inject<MatBottomSheetRef<CandidateAnalysisComponent>>(MatBottomSheetRef);
    } else {
      this.showCloseButton = false;
    }
  }

  close() {
    this._bottomSheetRef.dismiss();
  }
}
